export const GET_CASE_NUMBER = "GET_CASE_NUMBER"
export const GET_CASE_DETAILS = 'GET_CASE_DETAILS';

export const getCaseNumber = (caseNumber) => {
    
    return {
      type: GET_CASE_NUMBER, caseNumber
    }
  }